/**
 * Adding the constants in a separate file to make it possible to include it outside our app.
 */
import type { PlacementOptions } from '@neo4j-ndl/react';

export interface OnboardingStep {
  id: string;
  beforeActions: string;
  placement?: PlacementOptions;
  header?: string;
  body: string | React.ReactNode;
  hasAnchorPortal?: boolean;
  className?: string;
  customNextLabel?: string;
}

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    id: 'first-dashboard-step-1',
    beforeActions: '1/6',
    header: 'Great!',
    body: "Let's start by adding a first card to your dashboard.",
  },
  {
    id: 'first-dashboard-step-2',
    beforeActions: '2/6',
    hasAnchorPortal: true,
    className: 'z-60',
    placement: 'top-middle-bottom-middle',
    body: (
      <>
        The "<span className="font-bold">Preview</span>" button will let you generate a preview of the example query
        above.
      </>
    ),
  },
  {
    id: 'first-dashboard-step-3',
    beforeActions: '3/6',
    placement: 'middle-start-middle-end',
    body: 'You can change the visualization type from the select dropdown. Click “Next” to change from table view to a bar chart.',
  },
  {
    id: 'first-dashboard-step-4',
    beforeActions: '4/6',
    placement: 'bottom-end-bottom-start',
    body: 'The configurations tab is where you change the dimensions and styling for the visualization.',
  },
  {
    id: 'first-dashboard-step-5',
    beforeActions: '5/6',
    placement: 'bottom-end-bottom-start',
    body: 'Save the card to add it to your dashboard.',
  },
  {
    id: 'first-dashboard-step-6',
    beforeActions: '6/6',
    customNextLabel: 'Got it',
    header: 'You added your first card!',
    body: (
      <>
        More learning material, tours and support can be accessed from the
        <span className="font-bold"> help panel</span>.
      </>
    ),
  },
];
